import React, { useEffect, useState } from "react";
import { Card, Badge, Button } from "react-bootstrap";
import { ReactComponent as Clock } from "../../../../assets/images/clock.svg";

import { ReactComponent as MapPin } from "../../../../assets/images/dark-location-icon.svg";

import "../../Jobs.scss";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Copy, Send, Users } from "lucide-react";
import { toast } from "sonner";
import {
  FaFacebookF,
  FaLinkedinIn,
  FaWhatsapp,
  FaXTwitter,
} from "react-icons/fa6";
import {
  jobTracking,
  seheduleInterview,
} from "../../../../redux/slices/jobsSlice";
import CreatePostModal from "../../../community/components/create-post-modal/CreatePostModal";
import usePosts from "../../../community/hooks/usePosts";

const AppliedJobCard = ({
  application,
  categories,
  categoriesLoading,
  selectedRole,
  selectedJobType,
  selectedShiftType,
}) => {
  const job = application?.job;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { createPost } = usePosts();

  const [shareModal, setShareModal] = useState(false);
  const [showCreatePostModal, setShowCreatePostModal] = useState(false);
  const [preFilledContent, setPreFilledContent] = useState("");
  const [jobListingCategory, setJobListingCategory] = useState(null);

  useEffect(() => {
    if (categories && categories.length > 0) {
      const jobCategory = categories.find((cat) => cat.id === 9);
      if (jobCategory) {
        setJobListingCategory(jobCategory);
      }
    }
  }, [categories]);

  const createSlug = (text = "") => {
    return text
      .toString()
      .toLowerCase()
      .trim()
      .replace(/&/g, "and")
      .replace(/[^a-z0-9\s-]/g, "")
      .replace(/\s+/g, "-")
      .replace(/-+/g, "-")
      .replace(/^-|-$/g, "");
  };

  const buildJobSeoUrl = (jobObj) => {
    const titleSlug = createSlug(jobObj?.title);
    return titleSlug
      ? `/job-detail/${titleSlug}-${jobObj?.id}`
      : `/job-detail/${jobObj?.id}`;
  };

  const shareUrl = () => {
    return `${window.location.origin}${buildJobSeoUrl(job)}`;
  };

  const getApplyUrl = (url) => {
    if (!url) return "#";
    if (/^https?:\/\//i.test(url)) {
      return url;
    }
    return `https://${url}`;
  };

  const handleShareClick = (e) => {
    e.stopPropagation();
    setShareModal(true);
  };

  const closeShareModal = () => {
    setShareModal(false);
  };

  const generateJobPostContent = () => {
    const jobTitle = job?.title || "Job Opportunity";
    const companyName = job?.company_name || job?.company?.name || "Company";
    const salary = formatSalary(job?.salary);
    const city = job?.location_city || job?.location?.city;
    const state = job?.location_state || job?.location?.state;
    const location =
      city && state ? `${city}, ${state}` : "Location not specified";
    const applicationUrl = job?.application_url || "";

    let content = ` Job Opportunity: ${jobTitle}\n\n`;
    content += ` Company: ${companyName}\n`;
    content += ` Salary: ${salary}\n`;
    content += ` Location: ${location}\n`;
    if (job?.work_model) content += ` Work Mode: ${job.work_model}\n`;
    if (job?.job_type) content += ` Job Type: ${job.job_type}\n`;
    if (job?.shift_type) content += ` Shift: ${job.shift_type}\n`;
    if (job?.description) content += `\n Description:\n${job.description}\n`;
    if (applicationUrl) content += `\nApply here: ${applicationUrl}\n`;
    return content;
  };
  const avatarColors = [
    // '0195D3',
    // '16A34A',
    // 'DC2626',
    // '7C3AED',
    // 'EA580C',
    // '0D9488',
    // 'CA8A04',
    "054473",
    "0195D3",
    "7c3aed",
  ];

  const getAvatarColor = (key) => {
    let hash = 0;
    const str = String(key || "Company");

    for (let i = 0; i < str.length; i++) {
      hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }

    return avatarColors[Math.abs(hash) % avatarColors.length];
  };
  const avatarBg = getAvatarColor(
    job?.id || job?.company_name || job?.company?.name,
  );
  console.log("AppliedJobCard - application:", application);
  console.log("AppliedJobCard - job:", job);
  const hasJobMeta = Boolean(job?.promoted_by || job?.source_name);
  const formatSalary = (salary) => {
    if (!salary || (!salary.min && !salary.max)) {
      return "Salary not listed";
    }

    const min = salary.min ? Number(salary.min).toLocaleString() : null;

    const max = salary.max ? Number(salary.max).toLocaleString() : null;

    if (min && max) {
      return `$${min} - $${max}/${salary.period}`;
    }

    if (min) {
      return `From $${min}/${salary.period}`;
    }

    if (max) {
      return `Up to $${max}/${salary.period}`;
    }

    return "Compensation not disclosed";
  };
  const timeAgo = (date) => {
    if (!date) return "";

    const now = Date.now();
    const past = new Date(date).getTime();
    const diffMs = now - past;

    const seconds = Math.floor(diffMs / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);
    const months = Math.floor(days / 30);
    const years = Math.floor(days / 365);

    // Just now
    if (seconds < 60) return "Just now";

    // Minutes
    if (minutes < 60) return minutes === 1 ? "1 min ago" : `${minutes} min ago`;

    // Hours
    if (hours < 24) return hours === 1 ? "1 hour ago" : `${hours} hours ago`;

    // Weeks (ONLY exact multiples, up to 4 weeks)
    if (days >= 7 && days <= 28 && days % 7 === 0) {
      const weeks = days / 7;
      return weeks === 1 ? "1 week ago" : `${weeks} weeks ago`;
    }

    // Days (everything else under 30)
    if (days < 30) return days === 1 ? "1 day ago" : `${days} days ago`;

    // Months
    if (months < 12)
      return months === 1 ? "1 month ago" : `${months} months ago`;

    // Years
    return years === 1 ? "1 year ago" : `${years} years ago`;
  };

  const renderSalary = (salary) => {
    const text = formatSalary(salary);
    const slashIdx = text.lastIndexOf("/");
    if (slashIdx === -1) {
      return text;
    }
    return (
      <>
        {text.slice(0, slashIdx)}
        <span className="salary-period">{text.slice(slashIdx)}</span>
      </>
    );
  };

  const formatbonus = (bonus) => {
    if (!bonus) {
      return "Not listed";
    }

    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      // Optional: Use 'narrowSymbol' to ensure it just shows $
      currencyDisplay: "symbol",
      // Usually, salaries don't show cents. You can toggle this:
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(bonus);
  };

  const shareToSocialMedia = (platform) => {
    const applicationUrl = shareUrl();

    const jobTitle = job?.title || "this job opportunity";
    const companyName = job?.company_name || job?.company?.name || "Company";

    const shareText = `Check out ${jobTitle} at ${companyName}`;

    let url = "";

    switch (platform) {
      case "twitter":
        url = `https://twitter.com/intent/tweet?text=${encodeURIComponent(
          shareText,
        )}&url=${encodeURIComponent(applicationUrl)}`;
        break;

      case "facebook":
        url = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
          applicationUrl,
        )}`;
        break;

      case "whatsapp":
        url = `https://wa.me/?text=${encodeURIComponent(
          shareText + " " + applicationUrl,
        )}`;
        break;

      case "linkedin":
        url = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(
          applicationUrl,
        )}`;
        break;

      case "copy":
        navigator.clipboard
          .writeText(applicationUrl)
          .then(() => toast.success("Link copied to clipboard!"))
          .catch(() => toast.error("Failed to copy link"));
        closeShareModal();
        return;

      default:
        return;
    }

    if (url) {
      window.open(
        url,
        "_blank",
        "width=600,height=400,scrollbars=yes,resizable=yes",
      );
      closeShareModal();
    }
  };

  const handleInterviewResponse = (type) => {
    if (!application?.application_id) return;

    dispatch(
      seheduleInterview({
        applicationId: application.application_id,
        data: {
          response: type, // "accepted" or "rejected"
          note:
            type === "accepted"
              ? "I am available for interview"
              : "Not interested",
        },
      }),
    );
  };

  if (!job) {
    return (
      <Card className="applied-job-card mb-3">
        <Card.Body>
          <div className="no-data text-center">Job data not available</div>
        </Card.Body>
      </Card>
    );
  }

  return (
    <>
      <div className="contentwrap applied-job-card-contentwrap">
        <div className="job-card-header">
          <div className="job-icon">
            <img
              src={
                job?.profile_photo
                  ? `${process.env.REACT_APP_API_BASE_URL}/uploads/job_photos/${job.profile_photo}`
                  : `https://ui-avatars.com/api/?name=${encodeURIComponent(
                    job?.company_name || job?.company?.name || "Company",
                  )}&background=${avatarBg}&color=fff&size=100&bold=true`
              }
              alt={job?.company_name || job?.company?.name || "Company"}
              className="user-avatar"
              onError={(e) => {
                const target = e.target;
                target.onerror = null;
                target.src = `https://ui-avatars.com/api/?name=${encodeURIComponent(
                  job?.company_name || job?.company?.name || "Company",
                )}&background=${avatarBg}&color=fff&size=100&bold=true`;
              }}
            />
          </div>

          <div className="job-title-description">
            <div className="title-popular">
              <div className="d-flex align-items-center justify-content-between">
                <div className="job-title ">
                  {job?.company_name || job?.company?.name}
                </div>

                <div className="d-flex align-items-center gap-2 badge-container applied-badge">
                  <span className="badge populars">
                    {application?.status?.replaceAll("_", " ").toUpperCase()}
                  </span>
                  {/* <span
                    className={`badge populars ${
                      application?.status === "rejected"
                        ? "status-rejected"
                        : application?.status === "accepted"
                        ? "status-accepted"
                        : "status-pending"
                    }`}
                  >
                    {application?.status?.replaceAll("_", " ").toUpperCase()}
                  </span> */}

                  {job?.apply_count > 5 && (
                    <span className="badge populars">Popular</span>
                  )}
                </div>
              </div>
              <div className="job-type">{job?.title}</div>
            </div>
            <div className="job-description">
              {job.promoted_by && (
                <div className="tag">
                  <div className="tag-desc">Promoted by {job.promoted_by}</div>
                </div>
              )}
              {job?.source_name && (
                <span className="job-desc-text">
                  Responses managed off {job?.source_name}
                </span>
              )}
            </div>
          </div>
        </div>
        <div className="job-location">
          <MapPin size={14} />
          {(job?.location_city || job?.location?.city) &&
            (job?.location_state || job?.location?.state)
            ? `${job?.location_city ||
            job?.location?.city}, ${job?.location_state ||
            job?.location?.state}`
            : "Location not specified"}
        </div>
        {/* <div className="job-salary">
                {" "}
                {formatSalary(
                  job?.salary || {
                    min: job?.salary_min,
                    max: job?.salary_max,
                    period: job?.salary_period,
                  },
                )}
              </div> */}
        <div className="job-salary">
          {" "}
          {renderSalary(
            job?.salary || {
              min: job?.salary_min,
              max: job?.salary_max,
              period: job?.salary_period,
            },
          )}
        </div>

        <div
          className={`content ${application?.interview_response_status !== "rescheduled"
            ? "no-padding"
            : ""
            }`}
        >
          <div className="job-meta">
            <span className="posted-time">Application Status: <strong>{application?.status}</strong></span>
            <span className="job-schedule">
              <Clock size={14} />
              <span>{timeAgo(application?.applied_at)} </span>
            </span>
          </div>

          <div className="job-meta">
            {application?.disqualify_reason && (
              <div className="job-bonus">
                <span>Disqualify reason: </span>
                {application?.disqualify_reason}
              </div>
            )}
          </div>
          <div className="job-meta-grid">
            <div className="meta-item">
              <span className="meta-label">Bonus</span>
              <span className="meta-value">{formatbonus(job?.bonus)}</span>
            </div>

            {job?.job_requirements?.min_education && (
              <div className="meta-item">
                <span className="meta-label">Min Education</span>
                <span className="meta-value">
                  {job?.job_requirements?.min_education}
                </span>
              </div>
            )}

            {job?.job_requirements?.license_type && (
              <div className="meta-item">
                <span className="meta-label">Required License</span>
                <span className="meta-value">
                  {job?.job_requirements?.license_type}
                </span>
              </div>
            )}

            {job?.job_requirements?.min_years_experience && (
              <div className="meta-item">
                <span className="meta-label">Min Years Experience</span>
                <span className="meta-value">
                  {job?.job_requirements?.min_years_experience}
                </span>
              </div>
            )}

            {job?.specialty && (
              <div className="meta-item">
                <span className="meta-label">Specialty</span>
                <span className="meta-value">{job?.specialty}</span>
              </div>
            )}

            {job?.job_requirements?.certifications && (
              <div className="meta-item">
                <span className="meta-label">Required Certificate</span>
                <span className="meta-value">
                  {(() => {
                    try {
                      const value = job?.job_requirements?.certifications;

                      if (Array.isArray(value)) {
                        return value.join(", ");
                      }

                      const parsed = JSON.parse(value || "[]");

                      return Array.isArray(parsed)
                        ? parsed.join(", ")
                        : String(parsed);
                    } catch (e) {
                      return String(job?.job_requirements?.certifications);
                    }
                  })()}
                </span>
              </div>
            )}
          </div>
          <div className="job-meta">
            {application?.interview_time && (
              <div className="job-bonus">
                <span>Interview Time: </span>
                {new Date(application.interview_time).toLocaleString("en-US", {
                  hour: "numeric",
                  minute: "numeric",
                  hour12: true,
                  year: "numeric",
                  month: "short",
                  day: "numeric",
                })}{" "}
              </div>
            )}
          </div>
          <div className="job-meta">
            {application?.interview_message && (
              <div className="job-bonus">
                <span>Interviewer message:</span>
                {application?.interview_message}
              </div>
            )}
          </div>
          <div className="job-meta">
            {job?.hospital?.name && (
              <div className="job-bonus">
                <span>Hospital: </span>
                {job?.hospital?.name}
              </div>
            )}
          </div>

          <div className="job-schedule tags">
            {job?.work_model && (
              <div className="tag">
                <div className="tag-desc">{job.work_model}</div>
              </div>
            )}

            {job?.shift_type && (
              <div className="tag">
                <div className="tag-desc">{job.shift_type}</div>
              </div>
            )}
            {job?.job_type && (
              <div className="tag">
                <div className="tag-desc">{job.job_type}</div>
              </div>
            )}
            {job?.specialty && (
              <div className="tag">
                <div className="tag-desc">{job.specialty}</div>
              </div>
            )}
          </div>
        </div>
        {application?.status === "interview_scheduled" &&
          application?.interview_response_status === "rescheduled" && (
            <div className="buttons pt-0">
              <Button
                className="w-50 btn btn-secondary"
                onClick={(e) => {
                  e.stopPropagation();
                  handleInterviewResponse("accepted");
                }}
              >
                Accept Interview
              </Button>

              <Button
                className="w-50 btn btn-danger"
                onClick={(e) => {
                  e.stopPropagation();
                  handleInterviewResponse("rejected");
                }}
              >
                Decline Interview
              </Button>
            </div>
          )}
        {application?.status === "interview_scheduled" &&
          application?.interview_response_status !== "rescheduled" && (
            <div
              className={`notes ${application?.interview_response_status === "accepted"
                ? "text-success"
                : "text-danger"
                }`}
            >
              Note:{" "}
              {application?.interview_response_status === "accepted"
                ? "You have accepted this interview"
                : "You have declined this interview"}
            </div>
          )}

        {/* <div className="buttons pt-0">
                    <Button
                      className="w-100 btn btn-secondary"
                      onClick={async (e) => {
                        e.stopPropagation();
                        if (!job?.id) return;
          
                        const session_id = sessionStorage.getItem(
                          "comparison_session_id",
                        );
                        if (!session_id) return;
          
                        try {
                          // Track application click
                          dispatch(
                            jobTracking({
                              session_id,
                              event_type: "application_clicked",
                              job_id: job.id,
                              job_title: job?.title || null,
                              specialty: selectedRole || null,
                              job_type: selectedJobType?.[0] || null,
                              shift_type: selectedShiftType?.[0] || null,
                              company_name:
                                job?.company_name || job?.company?.name || null,
                              timestamp: new Date().toISOString(),
                            }),
                          );
          
                          // await dispatch(applyJob(job.id)).unwrap();
          
                          // ⭐ If job source is hospital → open internal page
                          if (job?.source === "hospital") {
                            navigate(`/job-detail/${job.id}`);
                            return;
                          }
                          // if (job?.source === "hospital") {
                          //   navigate(`/jobs/apply/${job.id}`);
                          //   return;
                          // }
          
                          // ⭐ Otherwise open external link
                          const url = getApplyUrl(job?.application_url);
                          if (url && url !== "#") {
                            window.open(url, "_blank", "noopener,noreferrer");
                          }
                        } catch (error) {
                          console.error("Apply failed:", error);
                        }
                      }}
                    >
                      Apply Now
                    </Button>
          
                    <Button
                      variant="link"
                      size="sm"
                      onClick={handleShareClick}
                      className="d-flex align-items-center gap-2 action-btn text-muted btn btn-secondary"
                    >
                      <Send size={24} />
                    </Button>
                    {shareModal && (
                      <div
                        className="modal-backdrop-overlay"
                        style={{
                          position: "fixed",
                          top: 0,
                          left: 0,
                          right: 0,
                          bottom: 0,
                          backgroundColor: "rgba(0, 0, 0, 0.6)",
                          backdropFilter: "blur(8px)",
                          WebkitBackdropFilter: "blur(8px)",
                          zIndex: 99998,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                        // onClick={closeShareModal}
                        onClick={(e) => {
                          e.stopPropagation(); // ✅ ADD THIS
                          closeShareModal();
                        }}
                      >
                        <div
                          className="modal-content-wrapper"
                          style={{
                            backgroundColor: "var(--mmp-surface)",
                            borderRadius: "12px",
                            maxWidth: "400px",
                            width: "90%",
                            boxShadow: "0 20px 25px -5px rgba(0, 0, 0, 0.1)",
                            zIndex: 99999,
                            position: "relative",
                          }}
                          onClick={(e) => e.stopPropagation()}
                        >
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              padding: "12px",
                              borderBottom: "1px solid var(--mmp-border)",
                            }}
                          >
                            <h3
                              style={{
                                fontSize: "18px",
                                fontWeight: "600",
                                color: "var(--mmp-text-primary)",
                                margin: 0,
                                lineHeight: "24px",
                              }}
                            >
                              Share Job
                            </h3>
                            <button
                              onClick={closeShareModal}
                              style={{
                                background: "transparent",
                                border: "none",
                                cursor: "pointer",
                                padding: "4px",
                                borderRadius: "4px",
                                color: "var(--mmp-text-secondary)",
                                fontSize: "24px",
                                lineHeight: 1,
                              }}
                              aria-label="Close"
                            >
                              ×
                            </button>
                          </div>
          
                          <div style={{ padding: "0" }}>
                            <div
                              onClick={() => shareToSocialMedia("twitter")}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "12px",
                                padding: "12px 24px",
                                cursor: "pointer",
                                borderBottom: "1px solid var(--mmp-border)",
                                transition: "background-color 0.2s ease",
                              }}
                              onMouseEnter={(e) =>
                                (e.currentTarget.style.backgroundColor = "var(--mmp-hover-bg)")
                              }
                              onMouseLeave={(e) =>
                                (e.currentTarget.style.backgroundColor = "transparent")
                              }
                            >
                              <div
                                style={{
                                  width: "22px",
                                  height: "22px",
                                  backgroundColor: "#1da1f2",
                                  borderRadius: "4px",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  color: "white",
                                }}
                              >
                                <FaXTwitter
                                  size={14}
                                  style={{
                                    display: "block",
                                    margin: "0 auto",
                                  }}
                                />
                              </div>
          
                              <span style={{ fontSize: "14px", fontWeight: "500" }}>
                                Share on Twitter
                              </span>
                            </div>
          
                            <div
                              onClick={() => shareToSocialMedia("facebook")}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "12px",
                                padding: "12px 24px",
                                cursor: "pointer",
                                borderBottom: "1px solid var(--mmp-border)",
                                transition: "background-color 0.2s ease",
                              }}
                              onMouseEnter={(e) =>
                                (e.currentTarget.style.backgroundColor = "var(--mmp-hover-bg)")
                              }
                              onMouseLeave={(e) =>
                                (e.currentTarget.style.backgroundColor = "transparent")
                              }
                            >
                              <div
                                style={{
                                  width: "22px",
                                  height: "22px",
                                  backgroundColor: "#1877f2",
                                  borderRadius: "4px",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  color: "white",
                                  fontSize: "10px",
                                  fontWeight: "bold",
                                }}
                              >
                                <FaFacebookF
                                  size={14}
                                  style={{
                                    display: "block",
                                    margin: "0 auto",
                                  }}
                                />
                              </div>
                              <span style={{ fontSize: "14px", fontWeight: "500" }}>
                                Share on Facebook
                              </span>
                            </div>
          
                            <div
                              onClick={() => shareToSocialMedia("whatsapp")}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "12px",
                                padding: "12px 24px",
                                cursor: "pointer",
                                borderBottom: "1px solid var(--mmp-border)",
                                transition: "background-color 0.2s ease",
                              }}
                              onMouseEnter={(e) =>
                                (e.currentTarget.style.backgroundColor = "var(--mmp-hover-bg)")
                              }
                              onMouseLeave={(e) =>
                                (e.currentTarget.style.backgroundColor = "transparent")
                              }
                            >
                              <div
                                style={{
                                  width: "22px",
                                  height: "22px",
                                  backgroundColor: "#25d366",
                                  borderRadius: "4px",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  color: "white",
                                  fontSize: "12px",
                                  fontWeight: "bold",
                                }}
                              >
                                <FaWhatsapp
                                  size={14}
                                  style={{
                                    display: "block",
                                    margin: "0 auto",
                                  }}
                                />
                              </div>
                              <span style={{ fontSize: "14px", fontWeight: "500" }}>
                                Share on WhatsApp
                              </span>
                            </div>
          
                            <div
                              onClick={() => shareToSocialMedia("linkedin")}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "12px",
                                padding: "12px 24px",
                                cursor: "pointer",
                                borderBottom: "1px solid var(--mmp-border)",
                                transition: "background-color 0.2s ease",
                              }}
                              onMouseEnter={(e) =>
                                (e.currentTarget.style.backgroundColor = "var(--mmp-hover-bg)")
                              }
                              onMouseLeave={(e) =>
                                (e.currentTarget.style.backgroundColor = "transparent")
                              }
                            >
                              <div
                                style={{
                                  width: "22px",
                                  height: "22px",
                                  backgroundColor: "#0077b5",
                                  borderRadius: "4px",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  color: "white",
                                  fontSize: "10px",
                                  fontWeight: "bold",
                                }}
                              >
                                <FaLinkedinIn
                                  size={14}
                                  style={{
                                    display: "block",
                                    margin: "0 auto",
                                  }}
                                />
                              </div>
                              <span style={{ fontSize: "14px", fontWeight: "500" }}>
                                Share on LinkedIn
                              </span>
                            </div>
          
                            <div
                              onClick={() => shareToSocialMedia("copy")}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "12px",
                                padding: "12px 24px",
                                cursor: "pointer",
                                transition: "background-color 0.2s ease",
                                borderBottomLeftRadius: "12px",
                                borderBottomRightRadius: "12px",
                              }}
                              onMouseEnter={(e) =>
                                (e.currentTarget.style.backgroundColor = "var(--mmp-hover-bg)")
                              }
                              onMouseLeave={(e) =>
                                (e.currentTarget.style.backgroundColor = "transparent")
                              }
                            >
                              <Copy
                                style={{
                                  width: "20px",
                                  height: "20px",
                                  color: "var(--mmp-text-secondary)",
                                }}
                              />
                              <span style={{ fontSize: "14px", fontWeight: "500" }}>
                                Copy Link
                              </span>
                            </div>
          
                            <div
                              onClick={(e) => {
                                e.stopPropagation();
                                closeShareModal();
                                const jobContent = generateJobPostContent();
                                setPreFilledContent(jobContent);
                                setShowCreatePostModal(true);
                              }}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "12px",
                                padding: "12px 24px",
                                cursor: "pointer",
                                borderTop: "1px solid var(--mmp-border)",
                                transition: "background-color 0.2s ease",
                                borderBottomLeftRadius: "12px",
                                borderBottomRightRadius: "12px",
                              }}
                              onMouseEnter={(e) =>
                                (e.currentTarget.style.backgroundColor = "var(--mmp-accent-bg)")
                              }
                              onMouseLeave={(e) =>
                                (e.currentTarget.style.backgroundColor = "transparent")
                              }
                            >
                              <Users
                                style={{
                                  width: "20px",
                                  height: "20px",
                                  color: "var(--mmp-accent)",
                                }}
                              />
                              <span
                                style={{
                                  fontSize: "14px",
                                  fontWeight: "500",
                                  color: "var(--mmp-accent)",
                                }}
                              >
                                Share to Community
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div> */}
      </div>

      {showCreatePostModal && (
        <CreatePostModal
          show={true}
          onHide={() => {
            setShowCreatePostModal(false);
            setPreFilledContent("");
          }}
          createPost={createPost}
          categories={categories}
          isLoading={categoriesLoading}
          initialCategory={jobListingCategory?.category_name || "Job Listing"}
          preFilledContent={preFilledContent}
          onpostSubmit={() => { }}
          onCategoryChange={() => { }}
        />
      )}
    </>
  );
};

export default AppliedJobCard;
